//<!----- Redirect From Cart Page To Home Page Code Start -----> //

if (window.location.pathname === '/cart') {
  window.location.replace('/');
}

//<!----- Redirect From Cart Page To Home Page Code End -----> //

//<!----- Add To Cart Disabled On Window Load Code Start -----> //

function enableCartButtons() {
  document
    .querySelectorAll('.js-go-cart-add-to-cart.product-form__submit, .productSticky-addcartbutton')
    .forEach((btn) => {
      btn.disabled = false;
    });
}

document
  .querySelectorAll('.js-go-cart-add-to-cart.product-form__submit, .productSticky-addcartbutton')
  .forEach((btn) => {
    btn.disabled = true;
  });

window.addEventListener('load', function () {
  setTimeout(enableCartButtons, 500);
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        const newButtons = node.querySelectorAll(
          '.js-go-cart-add-to-cart.product-form__submit, .productSticky-addcartbutton'
        );
        newButtons.forEach((btn) => (btn.disabled = false));
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

//<!----- Add To Cart Disabled On Window Load Code End -----> //

document.addEventListener('click', function (e) {
  const isQtyBtn = e.target.closest('.rebuy-cart__flyout-item-quantity-widget-button');
  const isRemoveBtn = e.target.closest('.rebuy-cart__flyout-item-remove');

  if (isQtyBtn || isRemoveBtn) {
    const checkoutBtn = document.querySelector('.rebuy-cart__checkout-button');

    if (!checkoutBtn) return;
    checkoutBtn.setAttribute('disabled', 'disabled');
    checkoutBtn.style.pointerEvents = 'none';
    checkoutBtn.style.opacity = '0.5';
    checkoutBtn.style.cursor = 'not-allowed';

    setTimeout(function () {
      checkoutBtn.removeAttribute('disabled');
      checkoutBtn.style.pointerEvents = '';
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.cursor = '';
    }, 5000);
  }
});

$(document).ready(function () {
  // $(document).find(".slide_video_item").each(function() {
  // var dataSrc = $(this).attr('data-frame');
  // $(this).find('.slide_iframe_video').attr('src', dataSrc);
  // });
  // =================//
  // $("details.mega-menu summary.list-menu__item").hover(function () {
  //   $(this).parents("details.mega-menu").attr("open", "open");
  // });
  // =================//
  //   $('.mainImageWithVideoSlideshow').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     speed: 300,
  //     // autoplay: true,
  //     autoplaySpeed: 5000,
  //     arrows: true,
  //     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" style="transform: rotate(90deg);"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  //     nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" style="transform: rotate(-90deg);"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
  //     fade: false,
  //     dots: false,
  // });

  $('.imainGreasistGallerySlide')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      infinite: true,
      asNavFor: '.imainGreasistNavbarSlide',
    })
    .on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
  $('.imainGreasistNavbarSlide').slick({
    slidesToShow: 5,
    slidesToScroll: 0,
    infinite: false,
    focusOnSelect: true,
    asNavFor: '.imainGreasistGallerySlide',
    dots: false,
    arrows: false,
    centerMode: true,
  });
  $('.imainGreasistNavbarSlide').slick('slickGoTo', 1);

  $('.testimonialGridListSlider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: false,
    dots: true,
  });

  // grid varinat select
  $(document).on('click', '.gridVariant .varinput', function () {
    var variantId = $(this).attr('data-variantId');
    var onSale = $(this).attr('data-on-sale') === 'true';
    var $info = $(this).parents('.card-information');
    $info.find('.default_price').first().text($(this).attr('data-price'));
    var $compare = $info.find('.card-compare-price').first();
    if (onSale) {
      $compare.text($(this).attr('data-compare-price'));
      $compare.closest('.price--on-sale').removeClass('hidden');
    } else {
      $compare.closest('.price--on-sale').addClass('hidden');
    }
    $(this).closest('.addBtn').find('.customForm .product-variant-id').val(variantId);
  });

  // greasist corner jquery
  $(document).on('click', '.greasist-block .block-heading', function () {
    var tab_id = $(this).attr('data-tab');
    $('.greasist-block .block-heading').removeClass('is__active');
    $('.main-block-content').removeClass('is__active');
    $(this).addClass('is__active');
    $('#' + tab_id).addClass('is__active');
  });
  if ($(window).width() < 990) {
    $('#columnGridListInstagram').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      cssEase: 'linear',
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  $(document).on('click', 'div#rc_radio_options .rc_block__type', function () {
    var value = $(this).prev('input[type="radio"]').val();
    $(document).find('div#rc_radio_options .rc_block__type').removeClass('rc_block__type--active');
    // $(this).addClass("is__active");
    $(this).closest('.rc_block__type').addClass('rc_block__type--active');
    if ($(this).hasClass('rc_block__type__onetime')) {
      $(document).find('.rc_block__type__autodeliver .rc_label__deliver_every select.rc_select__frequency').val('');
    } else {
      var value = $(document).find('.rc_radio__frequency input[type="radio"]:checked').val();
      $(document)
        .find('.rc_block__type__autodeliver .rc_label__deliver_every select.rc_select__frequency')
        .val(value);
    }
    var subPrice = $(this).find('.rc_label .rc_price').text();
    var subCurrency = $(this).find('.rc_label .rc_price').attr('data-currency');
    if (subPrice != undefined && subPrice != '') {
      $(document)
        .find('.productSticky-price .price-item')
        .text(subPrice + ' ' + subCurrency);
    }
  });

  $(document).on('click', '.rc_select  label.rc_frequency_type_label', function () {
    var value = $(this).prev('input[type="radio"]').val();
    $(document).find('.rc_block__type__autodeliver .rc_label__deliver_every select.rc_select__frequency').val(value);
  });
  $(document).on('click', '.product-form__input--pill label', function () {
    $(document).find('.rc_label__onetime').trigger('click');
  });

  // ------------product-sticky-add-to-cart------------//
  var stickyScrollDiv = document.querySelector('.main-productGrid');
  var productSticky = document.querySelector('.product--single__sticky');
  var mainSticky = document.querySelector('body');
  if (productSticky != null) {
    window.onscroll = function () {
      stickyAddToCart();
    };
    // var sticky = stickyScrollDiv.offsetHeight;
    var sticky = stickyScrollDiv.offsetTop;
    function stickyAddToCart() {
      if (window.pageYOffset > sticky) {
        productSticky.classList.add('is-sticky');
        mainSticky.classList.add('product-is-sticky');
      } else {
        productSticky.classList.remove('is-sticky');
        mainSticky.classList.remove('product-is-sticky');
      }
    }
  }
  $(document).on('click', '.productSticky-button .productSticky-addcartbutton', function () {
    $(document).find('.product-form__buttons .product-form__submit').trigger('click');
    $(this).find('.stickyAdd_to_cartText').hide();
    $(this).find('.loading__spinner').removeClass('hidden');
    setTimeout(() => {
      $(this).find('.stickyAdd_to_cartText').show();
      $(this).find('.loading__spinner').addClass('hidden');
    }, 2500);
  });

  //  function rebuyProductGridLoop() {
  //    if($(document).find('.drawer__footer .rebuy-widget .rebuy-product-block').length < 1){
  //    $('.drawer .drawer__footer').load(location.href + " .drawer .drawer__footer>*");
  //    }
  //  }
  // var interval = self.setInterval(function(){rebuyProductGridLoop()},500);

  $(document).on('click', '.rebuy-widget .rebuy-product-grid .rebuy-product-actions', function (event) {
    event.preventDefault();
    if ($(this).find('span').text() == 'Adding...') {
      setTimeout(() => {
        // $('.drawer .drawer__inner').load(location.href + " .drawer .drawer__inner>*");
        $('.drawer .drawer__inner cart-drawer-items').load(
          location.href + ' .drawer .drawer__inner cart-drawer-items>*'
        );
        $('.cart-drawer .totals').load(location.href + ' .cart-drawer .totals>*');
        $('.cart-drawer .cart-shipping-bar').load(location.href + ' .cart-drawer .cart-shipping-bar>*');
      }, 2000);
    }
  });

  var mainProductGrid = document.querySelector('.main-productGrid');
  var articeFAQ = document.querySelector('.article-template__faq');

  if (mainProductGrid != null || articeFAQ != null) {
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
      shrink() {
        this.isClosing = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) {
          this.animation.cancel();
        }
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 500,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        if (this.animation) {
          this.animation.cancel();
        }
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 500,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
      }
    }
    document.querySelectorAll('details.details__accordion').forEach((el) => {
      new Accordion(el);
    });
  }

  // -----------start-colllection-js------------//
  $(document).on('click', '.customTagFilter label.facets__label', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(document).find('.customTagFilter label.facets__label').removeClass('active');
      $(this).addClass('active');
    }
  });

  $(document).on('click', '#Details-sortFilter label.facets__label', function () {
    var value = $(this).attr('data-value');
    $(document).find('.facets-vertical select.facet-filters__sort').val(value);
    $('.facets-vertical select').find('option').removeAttr('selected');
    $('.facets-vertical select')
      .find('option')
      .each(function () {
        if ($(this).val() == value) {
          $(this).attr('selected', true);
        }
      });
  });

  $(document).on('click', '.collectionsNav--filter .collectionsNav--filter-btn', function () {
    $(this).toggleClass('is-active');
    $(document).find('.collectionsNav--filter #all-collectionslink').slideToggle('500');
  });
  // -----------end-colllection-js------------//

  $(document).on('click', '.vedio_mute_icon_play', function () {
    $(this).hide();
    var thisClosest = $(this).closest('.fullVideo--pausePlay');
    thisClosest.find('.vedio_mute_icon_pause').show();
    if (thisClosest.find('.videoOverly video').prop('muted', true)) {
      thisClosest.find('.videoOverly video').prop('muted', false);
    }
  });
  $(document).on('click', '.vedio_mute_icon_pause', function () {
    $(this).hide();
    var thisClosest = $(this).closest('.fullVideo--pausePlay');
    thisClosest.find('.vedio_mute_icon_play').show();
    if (thisClosest.find('.videoOverly video').prop('muted', false)) {
      thisClosest.find('.videoOverly video').prop('muted', true);
    }
  });

  // $(document).on("click",".youtubeVedio_mute_icon_play",function(event) {
  //    $(this).hide(); var thisClosest = $(this).closest('.fullVideo--pausePlay');
  //      thisClosest.find('.youtubeVedio_mute_icon_pause').show();
  //      if(thisClosest.find(".slide_iframe_video").prop('muted', true) )
  //      {
  //       thisClosest.find(".slide_iframe_video").prop('muted', false);
  //      }
  //    });
  //   $(document).on("click",".youtubeVedio_mute_icon_pause",function(event) {
  //    $(this).hide(); var thisClosest = $(this).closest('.fullVideo--pausePlay');
  //      thisClosest.find('.youtubeVedio_mute_icon_play').show();
  //      if(thisClosest.find(".slide_iframe_video").prop('muted', false) )
  //      {
  //       thisClosest.find(".slide_iframe_video").prop('muted', true);
  //      }
  //    })
  //------------blog-page-filter----------//

  $(document).on('click', '.tagFilter--wrapper .filter-list-title', function () {
    $(document).find('.tagFilter--wrapper .blog--tagFilter-list').slideToggle('slow');
  });
  //------------book landing carousel----------//

  $('.page-bl--carousel').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

/*// =======================custom-js-code================//*/
//  window.onscroll = function() {onscrollFunction()};
//   function onscrollFunction() {
//   var seenBlock = document.querySelector("#mainSeenBlockSections");
//   var seenTop = seenBlock.offsetTop - seenBlock.offsetHeight;
//  var seeScroll = document.querySelector("#mainSeenBlockSliderid");
//     if (window.pageYOffset > seenTop) {
//       seenBlock.classList.add("is-sticky");
//       var lastScrollLeft = 0;
//       var documentScrollLeft = seeScroll.scrollLeft();
//       if (lastScrollLeft != documentScrollLeft) {
//       console.log('scroll x');
//       lastScrollLeft = documentScrollLeft;
//       }

//     }
//     else {
//       seenBlock.classList.remove("is-sticky");
//     }

// }

window.addEventListener('wheel', (event) => {
  // event.preventDefault();
  var seenBlock = document.querySelector('#mainSeenBlockSections');
  if (seenBlock != null) {
    var seeScroll = document.querySelector('#mainSeenBlockSlider');
    var seenTop = seenBlock.offsetTop - seenBlock.offsetHeight;
    if (window.pageYOffset > seenTop) {
      seeScroll.scrollBy({
        left: event.deltaY < 0 ? -100 : 10,
      });
    }
  }
});

//   $(document).on("click","#discountAdd",function() {
//     console.log('Reuzel')
//       // window.location.href = "http://www.google.com";
//      setTimeout(function() {
//     window.location.href = "https://www.reuzel.com/checkouts/c/4409b6f1fe28c2dde35f9f86426926d5?_ga=2.267319943.881665062.1722835945-721761160.1720785300";
//    }, 2000);
//        // $("a.go-cart__button.button.cta.js-go-checkout__button").trigger("click");
// });

function pickyComboLoop() {
  const prodHandles = [
    'the-full-routine-tat-bundle-3-each',
    'clean-fresh-beard-shave-intro',
    'new-piglet-barber-pole',
    'new-combo-2',
    'road-trip-clay-matte-pomade',
    'buy-6-retail-size-daily-shampoo-get-1-for-backbar-free',
    'buy-6-retail-size-3-in-1-shampoo-get-1-for-backbar-free',
    'buy-6-retail-size-scrub-shampoo-get-1-for-backbar-free',
    'buy-6-11-83oz-daily-conditioner-get-1-for-backbarfree',
    'buy-6-retail-size-hair-tonic-get-1-for-backbar-free',
    'buy-6-retail-size-grooming-tonic-get-2-for-backbar-free',
    'buy-6-retail-size-spray-grooming-tonic-get-2-for-backbar-free',
    'buy-6-retail-size-surf-tonic-get-2-for-backbar-free',
    'buy-6-3-38oz-refresh-no-rinse-beard-wash-get-2-6-76oz-for-backbar-free',
    'buy-6-concrete-6-extreme-pomades-get-2-pomade-displays-free',
    'buy-6-clay-6-fiber-pomades-get-2-pomade-displays-free',
    'buy-6-pink-6-green-pomades-get-2-pomade-displays-free',
    'new-combo',
    'new-combo-3',
    'new-combo-4',
  ];
  var i,
    prodHandle,
    pathname = window.location.pathname;
  for (i = 0; i < prodHandles.length; ++i) {
    prodHandle = '/products/' + prodHandles[i];
    if (prodHandle == pathname) {
      console.log('loop', prodHandle);
      if ($(document).find('.product-block__form-installment .picky-combo-container').length) {
        $(document).find('.main-productGrid .product__info-container').addClass('order_picky-widget');
        $(document).find('.product-block__form-installment').addClass('last_picky-widget');
      }
    }
  }
}
var interval = self.setInterval(function () {
  pickyComboLoop();
}, 80);